var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('navBar'),_c('router-view'),_c('img',{ref:"topbtn",staticClass:"topbtn",attrs:{"src":require("@/assets/top.png"),"alt":""},on:{"click":_vm.topFunction}}),_c('cuFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }